export default "__VITE_PUBLIC_ASSET__510a1aaf__"